<div class="pagination-container" *ngIf="totalPages > 0">
  <div class="pagination-info">
    {{ 'COMMON.PAGINATION.SHOWING' | translate }} 
    <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> 
    - 
    <strong>{{ Math.min(currentPage * pageSize, totalItems) }}</strong> 
    {{ 'COMMON.PAGINATION.OF' | translate }} 
    <strong>{{ totalItems }}</strong>
  </div>

  <div class="pagination-controls">
    <button 
      class="pagination-btn" 
      [disabled]="currentPage === 1" 
      (click)="onFirstPage()"
      [title]="'COMMON.PAGINATION.FIRST' | translate"
    >
      <fa-icon [icon]="faAngleDoubleLeft"></fa-icon>
    </button>
    
    <button 
      class="pagination-btn" 
      [disabled]="currentPage === 1" 
      (click)="onPrevPage()"
      [title]="'COMMON.PAGINATION.PREVIOUS' | translate"
    >
      <fa-icon [icon]="faChevronLeft"></fa-icon>
    </button>

    <div class="pagination-pages">
      <button 
        *ngFor="let page of pages" 
        class="page-btn" 
        [class.active]="page === currentPage"
        (click)="onPageClick(page)"
      >
        {{ page }}
      </button>
    </div>

    <button 
      class="pagination-btn" 
      [disabled]="currentPage === totalPages" 
      (click)="onNextPage()"
      [title]="'COMMON.PAGINATION.NEXT' | translate"
    >
      <fa-icon [icon]="faChevronRight"></fa-icon>
    </button>

    <button 
      class="pagination-btn" 
      [disabled]="currentPage === totalPages" 
      (click)="onLastPage()"
      [title]="'COMMON.PAGINATION.LAST' | translate"
    >
      <fa-icon [icon]="faAngleDoubleRight"></fa-icon>
    </button>
  </div>
</div>
